/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { Fragment } from "react";
import { CategoryContent } from "../../organisms/footer/footer";

interface FooterColumnDataProps {
    columnData: CategoryContent;
}

const getUrlByFieldType = ({
    link,
    fieldType,
}: {
    link: string;
    fieldType: string | undefined | null;
}) => {
    if (!fieldType) return link;

    switch (fieldType) {
        case "tel":
            return `tel:${link}`;
        case "mail":
            return `mailto:${link}`;
        case "map": {
            const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                link
            )}`;
            return googleMapsUrl;
        }

        default:
            return link;
    }
};

const FooterColumnData = ({ columnData: col }: FooterColumnDataProps) => {
    const columnsIsCentralOfCall = col?.nombreCategoria?.includes("llamadas");
    return (
        <div
            className={`o_footer__col`}
            key={`footer-col-${col.nombreCategoria}`}
        >
            <h5 tabIndex={0} className="o_footer__title">
                {col.nombreCategoria}
            </h5>
            <ul className="o_footer__list">
                {col.referenciaSubcategorias.map((subCat) => {
                    return (
                        <Fragment
                            key={`footer-item-${col.nombreCategoria}-${subCat.nombreSubcategoria}`}
                        >
                            {columnsIsCentralOfCall && (
                                <li
                                    tabIndex={0}
                                    className="o_footer__item o_footer__item--call"
                                >
                                    {subCat.nombreSubcategoria}
                                </li>
                            )}
                            <li className={`o_footer__item`}>
                                <a
                                    className={`o_footer__link ${
                                        subCat.tipoCampo
                                            ? `o_footer__link--${subCat.tipoCampo}`
                                            : ""
                                    }`}
                                    title={subCat.nombreSubcategoria}
                                    rel="noopener noreferrer"
                                    referrerPolicy="no-referrer"
                                    href={
                                        getUrlByFieldType({
                                            link: subCat.link!,
                                            fieldType: subCat.tipoCampo,
                                        })!
                                    }
                                >
                                    {columnsIsCentralOfCall
                                        ? subCat.link
                                        : subCat.nombreSubcategoria}
                                </a>
                            </li>
                        </Fragment>
                    );
                })}
            </ul>
        </div>
    );
};

export default FooterColumnData;
